// Library import
import { createRoot } from 'react-dom/client';
import { Table, Pagination } from 'react-bootstrap';
import Proptypes from 'prop-types';
import { useEffect, useState } from 'react';
import { truncateString } from '@/config/mixins';
import { formatDate } from '@/config/day';

const ActivityLogListView = ({ logsData }) => {
  const [logs, setLogs] = useState(logsData?.data || []);

  useEffect(() => {
    setLogs(logsData?.data);
  }, []);

  return (
    <div className='page-wrapper px-4'>
      <div className='create-btn my-3 d-flex justify-content-end'></div>
      <div className='list-tabler-wrapper'>
        <Table>
          <thead>
            <tr>
              <th>名前</th>
              <th>IPアドレス</th>
              <th>日付</th>
              <th>アクション</th>
            </tr>
          </thead>
          <tbody>
            {logs?.map((log, index) => (
              <tr key={index}>
                <td>{log.user_name}</td>
                <td>{log.ip}</td>
                <td>{formatDate(log?.created_at, 'YYYY-MM-DD HH:mm')}</td>
                <td>{truncateString(log.subject, 50)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      {/* Pagination area */}
      {logsData?.total > logsData?.per_page && (
        <Pagination>
          <Pagination.First href={logsData?.first_page_url} />
          <Pagination.Prev href={logsData?.prev_page_url} />

          {logsData?.links.slice(1, -1)?.map((link, idx) => (
            <Pagination.Item key={idx} href={link?.url} active={link?.active}>
              {link?.label}
            </Pagination.Item>
          ))}

          <Pagination.Next href={logsData?.next_page_url} />
          <Pagination.Last href={logsData?.last_page_url} />
        </Pagination>
      )}
    </div>
  );
};
export default ActivityLogListView;

ActivityLogListView.prototype = {
  logsData: Proptypes.object
};

let element = null;

document.addEventListener('DOMContentLoaded', function (event) {
  if (!element) {
    element = document.getElementById('ActivityLogListView');
    const logsData = element?.dataset?.logs && JSON.parse(element.dataset.logs);
    const root = element && createRoot(element);

    if (element) root.render(<ActivityLogListView logsData={logsData} />);
  }
});
